import type { Bilingual } from '../bilingual.js';
import { useBilingual } from '../locale-provider.js';

/* Copy dos primitivos de filtro reusáveis (ADR-0704): faceta multi-seleção. O `SegmentedControl`
   não tem texto próprio — só `ariaLabel`/`label` recebidos por prop dos call sites. */
interface FiltersContent {
  readonly facetMultiSelect: {
    readonly noOptions: string;
    readonly clearSelection: string;
  };
}

const FILTERS_CONTENT: Bilingual<FiltersContent> = {
  'pt-BR': {
    facetMultiSelect: {
      noOptions: 'Sem opções.',
      clearSelection: 'Limpar seleção',
    },
  },
  'en-US': {
    facetMultiSelect: {
      noOptions: 'No options.',
      clearSelection: 'Clear selection',
    },
  },
};

export const useFiltersContent = (): FiltersContent => useBilingual(FILTERS_CONTENT);
